import { cx } from '@onbeam/business-styled-system/css';
import { text } from '@onbeam/business-styled-system/patterns';

export const desktopNavItemStyles = cx(
  'group',
  text({
    color: 'mono.primaryBg',
    pointerEvents: 'all',
    transition: 'colors',
    overflow: 'hidden',
    position: 'relative',

    '&[href]': {
      cursor: 'pointer',
    },
    _hoverFocusActive: {
      color: 'mono.tertiary',
    },
    '&[target="_blank"]': {
      _before: {
        transition: 'opacity',
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        w: '[1rem]',
        zIndex: 2,
        pointerEvents: 'none',
        bg: '[linear-gradient(270deg, transparent 0%, token(colors.mono.primaryFg) 100%)]',
        opacity: 0,
      },
      _hover: {
        _before: {
          opacity: 1,
        },
      },
    },
  }),
);
